import Icon from '@/components/ui/AppIcon';

interface AddOn {
  id: string
  icon: string
  title: string
  description: string
  priceRange: string
}

const AddOnsSection = () => {
  const addOns: AddOn[] = [
    {
      id: 'addon_equipment',
      icon: 'WrenchScrewdriverIcon',
      title: 'Premium Equipment',
      description: 'Upgrade to commercial-grade appliances and fixtures',
      priceRange: '$2,000 - $8,000',
    },
    {
      id: 'addon_branding',
      icon: 'PaintBrushIcon',
      title: 'Custom Branding',
      description: 'Professional signage, logos, and exterior graphics',
      priceRange: '$1,500 - $5,000',
    },
    {
      id: 'addon_layout',
      icon: 'Square3Stack3DIcon',
      title: 'Layout Customization',
      description: 'Modify interior layout to match your workflow',
      priceRange: '$1,000 - $4,000',
    },
    {
      id: 'addon_hvac',
      icon: 'FireIcon',
      title: 'Advanced HVAC',
      description: 'Upgraded heating and cooling systems',
      priceRange: '$3,000 - $6,000',
    },
    {
      id: 'addon_solar',
      icon: 'SunIcon',
      title: 'Solar Power System',
      description: 'Eco-friendly solar panels and battery storage',
      priceRange: '$5,000 - $12,000',
    },
    {
      id: 'addon_deck',
      icon: 'HomeModernIcon',
      title: 'Outdoor Deck',
      description: 'Extended customer seating and service area',
      priceRange: '$3,500 - $8,000',
    },
  ]

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="reveal text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6">
            Optional <span className="text-primary">Add-Ons</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Customize your container with additional features and upgrades to perfectly match your business needs.
          </p>
        </div>

        {/* Add-Ons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {addOns.map((addon, index) => (
            <div
              key={addon.id}
              className="reveal p-6 border-2 border-gray-200 rounded-2xl hover:border-primary hover:shadow-lg transition-all cursor-pointer"
              style={{ animationDelay: `${0.1 * (index + 1)}s` }}
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <Icon name={addon.icon as any} size={28} className="text-primary" />
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold font-montserrat text-foreground mb-2">
                {addon.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                {addon.description}
              </p>

              {/* Price Range */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <span className="text-xs text-muted-foreground uppercase font-semibold">Price Range</span>
                <span className="text-lg font-bold text-primary">{addon.priceRange}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="reveal text-center mt-16">
          <p className="text-muted-foreground mb-4">
            Need a custom configuration? We can build exactly what you need.
          </p>
          <a
            href="/get-a-quote"
            className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-4 transition-all"
          >
            Discuss Custom Options
            <Icon name="ArrowRightIcon" size={20} />
          </a>
        </div>
      </div>
    </section>
  )
}

export default AddOnsSection